import { Box, Card, CardContent, Typography } from '@mui/material';
import notebookIcon from '@/assets/images/notebook-new.svg';
import usersGroupRoundedIcon from '@/assets/images/users-group-rounded.svg';
import hourglassLineIcon from '@/assets/images/hourglass-line.svg';
import responsesThisWeekIcon from '@/assets/images/responses-this-week.svg';

export type SummaryCardIconName = 'notebook' | 'usersGroup' | 'responses' | 'pending';

const SUMMARY_ICONS: Record<SummaryCardIconName, string> = {
  notebook: notebookIcon,
  usersGroup: usersGroupRoundedIcon,
  responses: responsesThisWeekIcon,
  pending: hourglassLineIcon,
};

const iconSize = { width: 26, height: 26 };

interface QuestionnaireSummaryCardProps {
  title: string;
  value: string | number;
  icon: SummaryCardIconName;
}

export function QuestionnaireSummaryCard({ title, value, icon }: QuestionnaireSummaryCardProps) {
  const iconSrc = SUMMARY_ICONS[icon];

  return (
    <Card
      elevation={0}
      sx={{
        width: '100%',
        maxWidth: 'none',
        height: '100%',
        minWidth: 0,
        minHeight: 84,
        borderRadius: '14px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#dbe6eb',
        bgcolor: '#fff',
        opacity: 1,
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <CardContent
        sx={{
          p: { xs: 1.25, sm: 1.5 },
          height: '100%',
          '&:last-child': { pb: { xs: 1.25, sm: 1.5 } },
        }}
      >
        <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center', height: '100%' }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: '#e8f6fb',
              color: '#1eaad8',
              flexShrink: 0,
            }}
          >
            <Box component="img" src={iconSrc} alt="" sx={{ ...iconSize, display: 'block' }} />
          </Box>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              component="div"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: { xs: '24px', sm: '28px' },
                lineHeight: 1,
                color: '#0f172a',
                whiteSpace: 'nowrap',
              }}
            >
              {value}
            </Typography>
            <Typography
              sx={{
                mt: 0.5,
                fontFamily: 'Arial, sans-serif',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: { xs: '13px', sm: '14px' },
                lineHeight: '140%',
                letterSpacing: '0%',
                color: '#667085',
                overflowWrap: 'anywhere',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
